



















































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import SchemaEditor from '@/components/SchemaEditor.vue';

@Component({
  components: {
    SchemaEditor,
  },
})
export default class DataSchema extends Vue {
  @Prop({ default: {} }) private deviceType!: any;
  @Prop() private isAdminDeviceTypeSettings!: boolean;

  private tab: number = 0;
  private activeTab: number = 0;

  private isUplink: boolean = true;
  private isDownlink: boolean = false;
  private schemaError: string = '';
  private type: string = 'uplink';
  private tabDisplay: number = 1;
  private linkType: number = 1;

  private onTabChange() {
    if (this.isUplink) {
      this.isDownlink = true;
      this.type = 'downlink';
      this.isUplink = false;
    } else {
      this.isDownlink = false;
      this.type = 'uplink';
      this.isUplink = true;
    }
  }

  private changeTab(tab: number) {
    this.tabDisplay = tab;
  }

  private saveSchema(output: any) {
    this.schemaError = '';
    this.deviceType.schema_fields = output;
    this.$emit('saveDeviceType', this.deviceType);
  }
}

